import { useState } from 'react';
import './App.css';
import Video from './pages/video';
import Image from './pages/image';
import Tab from './layout/tab';
import Login from './pages/login';

function App() {
  const [user, setUser] = useState(null)
  const [page, setPage] = useState("Video")
  return (
    <div className="App">
      {user ?
        <>
          <Tab setPage={setPage} page={page} />
          {page === "Video" ?
            <Video user={user} />
            :
            <Image user={user} />
          }
        </>
        :
        <Login setUser={setUser}/>
      }
    </div>
  );
}

export default App;